import "core-js/modules/web.dom-collections.for-each.js";

if (document.body.classList.contains('archive-document') || document.body.classList.contains('archive-question')) {
  document.addEventListener('DOMContentLoaded', function () {
    /**
     * Reset the search form
     */
    var resetBtn = document.getElementById('reset');

    if (resetBtn) {
      resetBtn.addEventListener('click', function (e) {
        e.preventDefault();
        window.location.href = window.location.origin + window.location.pathname;
      });
    }

    var categories = document.querySelectorAll('.btn-check');
    categories.forEach(function (category) {
      category.addEventListener('change', function (e) {
        if (e.target.value == '') {
          window.location.href = window.location.origin + window.location.pathname;
        } else {
          this.form.submit();
        }
      });
    });
  });
}